import { Box, Button, Card, Stack, Typography } from "@mui/joy";
import { useNavigate } from "@tanstack/react-router";

const ChallengeTypeSelector = () => {
  const navigate = useNavigate();

  const challengeTypes = [
    {
      type: "CHECKIN" as const,
      name: "Check-in Challenge",
      description: "Improve visitation frequency and reward loyalty",
      icon: "📅",
    },
  ];

  const handleTypeSelect = (type: string) => {
    navigate({
      to: "/gym/$venueUuid/challenges/create",
      from: "/gym/$venueUuid/challenges/create",
      search: { type },
    });
  };

  return (
    <Box sx={{ padding: 3, maxWidth: 600, margin: "0 auto" }}>
      <Stack gap={3}>
        <Typography level="h3">Select a challenge type</Typography>

        <Stack gap={2}>
          {challengeTypes.map((challengeType) => (
            <Card
              key={challengeType.type}
              variant="outlined"
              sx={{
                cursor: "pointer",
                transition: "all 0.2s",
                "&:hover": {
                  borderColor: "primary.500",
                  transform: "translateY(-2px)",
                  boxShadow: "sm",
                },
              }}
              onClick={() => handleTypeSelect(challengeType.type)}
            >
              <Stack direction="row" gap={2.5} alignItems="center">
                <Typography level="h2">{challengeType.icon}</Typography>
                <Stack gap={1} flex={1}>
                  <Typography level="title-md" fontWeight="bold">
                    {challengeType.name}
                  </Typography>
                  <Typography level="body-sm" color="neutral">
                    {challengeType.description}
                  </Typography>
                </Stack>
                <Button size="sm">Select</Button>
              </Stack>
            </Card>
          ))}
          <Typography level="body-sm" color="neutral">
            More challenge types coming soon!
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
};

export default ChallengeTypeSelector;
